export const threeYearsBack = (sub = 1) => {
  const currentDate = new Date(); // Get the current date
  const threeYearsBack = new Date(); // Create a new Date object
  return new Date(threeYearsBack.setFullYear(currentDate.getFullYear() - sub)); // Subtract 3 years
};

export const incrementByOneYear = (sub = 1, date) => {
  const toDate = new Date(date);

  // Increment the year by 1
  toDate.setFullYear(toDate.getFullYear() + sub);
  // Convert the Date object back to a string in the format YYYY-MM-DD
  const incrementedDate = toDate.toISOString().split("T")[0];
  // Update the to_date field in the data object
  return incrementedDate;
};

export const monthYear = (date) => {
  // const myDate = date.getMonth();
  // const myYear = date.getFullYear();
  // return `${months[myDate]}  ${myYear}`;
};

// Create an array of month names
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
// export const EngTableHeads = {
//   Certificate: `Certificate`,
//   id: `Id`,
//   name_email: `Name & Email`,
//   phone_no: `Phone Number`,
//   city_postal: `City, Postal`,
//   created: `Created On`,
//   form_status: `Form Status`,
//   energy_cetificate: `Energy Certificate`,

//   payment_status: `Payment Status`,
//   Invoice: `Invoice`,
//   add_services: `Add on Services`,
//   chagres: `Charges`,
//   Action: `Action`,
// };
export const EngTableHeads  = [
  {
    label: "Id",
    id: "id",
    key: false,
    keyName: "",
  },
  {
    label: "Name & Email",
    id: "name_email",
    key: false,
    minWidth: 120,
  },
  {
    label: "Phone Number",
    id: "phone",
    key: false,
    minWidth: 120,
  },
  {
    label: "City, Postal",
    id: "city_postal",
    key: false,
    minWidth: 120,
  },
  {
    label: "Created On",
    id: "created",
    key: false,
    minWidth: 120,
  },
  {
    label: "Form Status",
    id: "status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Energy Certificate",
    id: "certificate_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Payment Status",
    id: "payment_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Invoice",
    id: "invoice",
    key: false,
    minWidth: 120,
  },
  {
    label: "",
    id: "collapse",
    key: false,
    minWidth: 20,
  },
];
// export const GermTableHeads = {
//   Certificate: `Zertifikat`,
//   id: `Id`,
//   name_email: `Name und E-Mail`,
//   phone_no: `Rufnummer`,
//   city_postal: `Stadt, Post`,
//   created: `Erstellt am`,
//   form_status: `Formular Status`,
//   energy_cetificate: `Energieausweis`,
//   payment_status: `Zahlungsstatus`,
//   Invoice: `Rechnung`,
//   add_services: `Zusätzliche Dienstleistungen`,
//   chagres: `Entgelte`,
//   Action: `Aktion`,
// };
export const GermTableHeads  = [
  {
    label: "Id",
    id: "id",
    key: false,
    keyName: "",
  },
  {
    label: "Name und E-Mail",
    id: "name_email",
    key: false,
    minWidth: 120,
  },
  {
    label: "Rufnummer",
    id: "phone",
    key: false,
    minWidth: 120,
  },
  {
    label: "Stadt, Post",
    id: "city_postal",
    key: false,
    minWidth: 120,
  },
  {
    label: "Erstellt am",
    id: "created",
    key: false,
    minWidth: 120,
  },
  {
    label: "Formular Status",
    id: "status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Energieausweis",
    id: "certificate_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Zahlungsstatus",
    id: "payment_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Rechnung",
    id: "invoice",
    key: false,
    minWidth: 120,
  },
  {
    label: "",
    id: "collapse",
    key: false,
    minWidth: 20,
  },
];
export const YYMMDD = (date) => {
  const yy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const dd = date.getDate().toString().padStart(2, "0");

  const formattedDate = `${yy}-${mm}-${dd}`;
  return formattedDate;
};
export const checkIfvalueExists = (obj, excludeObj) => { };
